'use client';
import React from 'react';
import { useLoyaltyService, useRegionCurrency, useUser } from '@skin-seoul/service';

import { LoyaltyBannerDesktop } from './LoyaltyBanner.Desktop';
import { LoyaltyBannerMobile } from './LoyaltyBanner.Mobile';
import { LoyaltyBannerSkeletonDesktop } from './LoyaltyBannerSkeleton.Desktop';
import { LoyaltyBannerSkeletonMobile } from './LoyaltyBannerSkeleton.Mobile';
import { LoyaltySignUpBannerDesktop } from './LoyaltySignUpBanner.Desktop';
import { LoyaltySignUpBannerMobile } from './LoyaltySignUpBanner.Mobile';

interface LoyaltyBannerContainerProps {
  memberSince?: string;
}

export const LoyaltyBannerContainer = ({ memberSince }: LoyaltyBannerContainerProps) => {
  const { user, isAuthenticated, isLoading: isUserLoading } = useUser();
  const { currency } = useRegionCurrency();
  const { useGetCustomerBalance } = useLoyaltyService();

  const { data: balanceData, isLoading: isBalanceLoading } = useGetCustomerBalance({
    customerId: String(user?.userId ?? ''),
    currency,
    enabled: isAuthenticated && Boolean(user?.userId),
  });

  // Show skeleton while loading user or balance data
  if (isUserLoading || isBalanceLoading) {
    return (
      <>
        <div className="tablet:hidden">
          <LoyaltyBannerSkeletonMobile />
        </div>
        <div className="hidden tablet:block">
          <LoyaltyBannerSkeletonDesktop />
        </div>
      </>
    );
  }

  // Show sign up banner if not authenticated or no data
  if (!isAuthenticated || !user?.userId || !balanceData) {
    return (
      <>
        <div className="tablet:hidden">
          <LoyaltySignUpBannerMobile />
        </div>
        <div className="hidden tablet:block">
          <LoyaltySignUpBannerDesktop />
        </div>
      </>
    );
  }

  // Show actual points banner
  return (
    <>
      <div className="tablet:hidden">
        <LoyaltyBannerMobile points={balanceData.availablePoints} />
      </div>
      <div className="hidden tablet:block">
        <LoyaltyBannerDesktop points={balanceData.availablePoints} memberSince={memberSince} />
      </div>
    </>
  );
};
